<template>       
<div class="main">
    <div class="left">
    <div class="row">
        <label class="title">request合法域名</label>
	    <div class="content">
	        <p v-for="(item, index) in info.requestList || [] " :key="index">{{item.domain}}</p>
	    </div> 
	</div>
	<div class="row">
        <label class="title">socket合法域名</label>
	    <div class="content">
            <p v-for="(item, index) in info.socketList || [] " :key="index">{{item.domain}}</p>
        </div>  
	</div>
    <div class="row">
        <label class="title">uploadFile域名</label>
        <div class="content">
            <p v-for="(item, index) in info.uploadFileList || [] " :key="index">{{item.domain}}</p>
        </div>  
    </div>
    <div class="row">
        <label class="title">downloadFile域名</label>
        <div class="content">
            <p v-for="(item, index) in info.downloadFileList || [] " :key="index">{{item.domain}}</p>
        </div>
    </div>
    </div>
    <div class="des">一个月内可申请{{totalServer}}次修改<br/>本月还可修改{{limit}}次</div>
</div>
</template>
<script>
import dao from '@/lib/dao';

export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        },
        limit: {
            type: Number,
            default: 0
        },
        totalServer: {
            type: Number,
            default: 0
        }
    }
}
</script>
<style lang="less" scoped>
.main {
    display: flex;
    font-size: 14px;
    .left {
        display: inline-block;
    
    	.row {
            line-height: 40px;
            min-height: 60px;
            padding: 0 10px;

            .title {
                width: 120px;
                display: inline-block;
                vertical-align: top;
                margin-right: 20px;
                text-align: left;
            }
            .content {
                line-height: 25px;
                display: inline-block;
                position: relative;
                width: 252px;
                margin-right: 70px;
                p {
                    color: #222;
                }
            }
        }
    }
    .des {
        display: flex;
        justify-content: center;
        padding-top: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/developer/DeveloperSetting.vue